import React from 'react'
import Svg from 'react-native-svg'
import svgs from './../../../assets/icons/export'
import PropTypes from 'prop-types'
import { ViewPropTypes } from 'react-native'

const Icon = ({ height, width, name, style, ...props }) => {
  const object = svgs[name]
  const IconContent = object?.svg || <></>
  return (
    <Svg height={height} width={width} viewBox={object?.viewBox || ''} style={style} tabIndex={-1}>
      {React.cloneElement(IconContent, {
        ...props
      })}
    </Svg>
  )
}

Icon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  name: PropTypes.string,
  style: ViewPropTypes.style
}

export default Icon
